export default "__VITE_ASSET__Do0QJ5oC__"